
import { MouseEventHandler, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'
import { Button, IconButton, Tooltip } from '@mui/material'
import { MainButtonsProps } from './types'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { icons } from '../../../../utils/icons';
import { useStyles } from './styles';
import { getLocalStorage, LocaleNameType } from '../../../../utils/crud/crypt';
import CreateFolioModal from '../createFolioModal';
import { Roles } from '../../../../utils/enums';
import { FolioTypeLowerCase } from '../../pages/dashboard/pages/detail/enums/folioType';

export const MainButtons = (props: MainButtonsProps) => {
  const { t } = useTranslation()
  const styles = useStyles();
  const navigate = useNavigate();
  const state: { isManagerOfDeparment: boolean, role: number } = getLocalStorage(LocaleNameType.STATE)
  const isManagerOfDepartment = state?.isManagerOfDeparment
  const isAdmin = state?.role === Roles.ADMIN

  const [addCircleOpen, setAddCircleOpen] = useState(false)

  const arrayOptions = [
    {
      title: t('reportFolio.newDashboard.btnsHeader.guard'),
      description: t('reportFolio.newDashboard.btnsDescription.guard'),
      icon: icons('guard'),
      path: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z",
      onClick: () => {
        closeAddCircle();
        navigate(FolioTypeLowerCase.PREVENTIVE);
      }
    },
    {
      title: t('reportFolio.newDashboard.btnsHeader.corrective'),
      description: t('reportFolio.newDashboard.btnsDescription.corrective'),
      icon: icons('corrective'),
      path: "m22.7 19-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z",
      onClick: () => {
        closeAddCircle()
        navigate(FolioTypeLowerCase.CORRECTIVE);
      }
    }
  ]

  const handleAddCircle: MouseEventHandler<HTMLButtonElement> = (e) => {


    if (isManagerOfDepartment || isAdmin) {
      setAddCircleOpen(true)
    } else {
      navigate(FolioTypeLowerCase.CORRECTIVE);
    }
  }

  const closeAddCircle = () => {
    setAddCircleOpen(false)
  }
  return (
    <>
      {(isManagerOfDepartment || isAdmin) && (
        <Button
          variant="outlined"
          color="primary"
          onClick={props.onReassignClick}
        >
          {t('reportFolio.newDashboard.btnsHeader.reasign')}
        </Button>
      )}

      {(isManagerOfDepartment || isAdmin) && (
        <Button variant="outlined" color="primary" onClick={props.onDeleteClick}>
          {t('reportFolio.newDashboard.btnsHeader.delete')}
        </Button>
      )}


      {(isManagerOfDepartment || isAdmin) && (
        <Button variant="outlined" color="primary" onClick={props.onCancelClick}>
          {t('reportFolio.newDashboard.btnsHeader.cancel')}
        </Button>
      )}

      <Tooltip title={t('ToolTips.create')}>
        <IconButton
          color="primary"
          sx={{
            p: 0,
            fontSize: 36,
          }}
          onClick={handleAddCircle}
        >
          <AddCircleIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>

      {!!props.counter && <IconButton
        sx={(styles.clean, (props.counter || 0) > 0 ? null : styles.hide)}
        onClick={() => {
          props.cleanFilter()
        }}
      >
        {icons('clean')}
      </IconButton>
      }

      <CreateFolioModal open={addCircleOpen} close={closeAddCircle} arrayButtons={arrayOptions} title={t('reportFolio.newDashboard.btnsDescription.title')} description={t('reportFolio.newDashboard.btnsDescription.description')} />
    </>
  )
}